
import VueCookies from 'vue-cookies'
　import md5 from 'js-md5'
import CryptoJS from 'crypto-js'
export function getmd5(str){
  return md5(str)
}
export function getSign(str){
  return md5("a2s2sdf43@dswe#fdfsdss@ssss"+str)
}
export function getOSName(){
var agent = navigator.userAgent.toLowerCase();
var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
  return "windows"
  }
if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
  return "windows"
}
if(isMac){
  return "mac"
}


//Android终端
let isAndroid = agent.indexOf('Android') > -1 || agent.indexOf('Adr') > -1;
if(isAndroid){
  return "android"
}
　   //Ios终端
let isiOS = !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
if(isiOS){
  return "ios"
}

let ismobile= navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
if(ismobile){
  return "mobile"
}
return ""

}
export function getOAImgUrl(imagename){

 if (imagename==null){
  return ""
 }
if(imagename.indexOf("$")>0){
   imagename=imagename.split("$")[0]
 }
       var url=getReqUrl()+"/picture/invoicing/approval/"+getValue("userid")+"/thumbnail/" + imagename
       return url
}

export function UrlDecode(key){
 return  decodeURIComponent(key)
}
export function hasPower(key){

 var powerjson=getValue("power")
 if(powerjson!=undefined&&powerjson!=""){
   if (powerjson.indexOf("==")>0){
    powerjson=Base64.decode(powerjson)

    //console.log("powerjson="+powerjson)
    if(powerjson!=undefined){
     var map=JSON.parse(powerjson)
     if(map!=undefined&&map!=null){
     var value=map[key]
     //console.log("key="+key+" value="+value)
     if (value!=undefined&&value=="0"){
        return false
     }
   }
    }
   }
 }


 return true
 }
 /*
 权限
 {
	"Purchase": "1",
	"Sell": "1",
	"Inventory": "1",
	"PurchaseReturns": "1",
	"SellReturns": "1",
	"Statistics": "0",
	"DataTrans": "1",
	"Account": "1",
	"BaseData": "1",
	"Receivable": "1",
	"OA": "1",
	"Orders": "1"
}

  */

export function getLang(name){
   //var lang=this.getlan('Name')
        if (name.indexOf("lang.")>0){
           return name;
        }
        return name;
  }
export function getHotelImgUrl(imagename){


  if(imagename.indexOf(";")>0){
     imagename=imagename.split(";")[0]
   }
   if(imagename.indexOf("$")>0){
    imagename=imagename.split("$")[0]
  }
         var url=getReqUrl()+"/picture/"+getValue("userid")+"/room/thumbnail/" + imagename
         return url
  }
  export function    getInvoiceImgUrl(imagename){
          if(imagename.indexOf("$")>0){
            imagename=imagename.split("$")[0]
          }
          var url= getReqUrl()+"/picture/invoicing/"+getValue("userid")+"/thumbnail/" + imagename
       // console.log("image url="+url);
            return url
 }


 export function    getUserImgUrl(imagename){
              if(imagename.indexOf("$")>0){
                imagename=imagename.split("$")[0]
              }

              var url= getReqUrl()+"/picture/user/"+getValue("userid")+"/thumbnail/" + imagename

                return url
 }

 export function    getAdminUserImgUrl(imagename){
  if(imagename.indexOf("$")>0){
    imagename=imagename.split("$")[0]
  }

  var url= getReqUrl()+"/picture/user/thumbnail/" + imagename

    return url
}


 export function    getSupplierImgUrl(imagename){
         if(imagename.indexOf("$")>0){
               imagename=imagename.split("$")[0]
          }
      var url= getReqUrl()+"/picture/supplier/"+getValue("userid")+"/thumbnail/" + imagename

                    return url
  }
  export function getIntValue(key){
var value=VueCookies.get(key);
if(value==null){
  return 0
}
if(value.length==0)
{
  return 0
}
    return parseInt(value);

  }
  export function getValue(key){
var value= VueCookies.get(key);
if(key=="isbuy"){
  if(value==undefined||value=="undefined"||value=="[]"){
    return "0"
  }
}
if(value==undefined||value=="undefined"){
  return undefined
}
return value;
  }
  export function setValue(key,value){
    if(value!=undefined){
      return VueCookies.set(key,value);
    }
    return false
  }
/*获取当前日期*/
export function getDay() {
  const nowDate = new Date();
  const date = {
    year: nowDate.getFullYear(),
    month: nowDate.getMonth() + 1,
    day: nowDate.getDate(),
  };
  const formattedMonth = date.month >= 10 ? date.month : "0" + date.month;
  const formattedDay = date.day >= 10 ? date.day : "0" + date.day;
  return `${date.year}-${formattedMonth}-${formattedDay}`;
  }
  export function getToDay() {
    const nowDate = new Date();
      const date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        day: nowDate.getDate(),
      };
      const formattedMonth = date.month >= 10 ? date.month : "0" + date.month;
      const formattedDay = date.day >= 10 ? date.day : "0" + date.day;
      return `${date.year}-${formattedMonth}-${formattedDay}`;
    }
  export function getReqUrl()
  {
 if(1==2){
  //ios mac app 要采用这个配置。因为ip是app传递过来
 var ip=getValue("ip")
 var port=getValue("port")
 if ( ip!=null&& ip!=undefined&&ip!='null'&&port!=null&&port!=undefined&&port!='null'){
  // this.alert_ok("cookies ip="+ ip+':'+port)

}else{
 ip=config.ip
 port=config.httpport
}

 return "//"+ip+':'+config.httpport
}else{
  //用于网页 iosbuy 和本地调试
  return config.url;

  //return "//"+"www.iosbuy.com"
  //return "//"+"107.182.186.227"
  //return "127.0.0.1:8081"
}


     }
     export function saveIP(ip) {

        if(window.location.host.indexOf(":")>0){
          var ip= window.location.host.split(":")[0]
         var  port= window.location.host.split(":")[1]
          if(ip!=null&&ip!=undefined&&ip!="null"){
            setValue('ip', ip);
            setValue('port', port);
          }

         }

    }
   export function isInAPP() {
        var url=getReqUrl();
       if (url.indexOf("iosbuy.com")>0||url.indexOf("thenurasia.com")>0||url.indexOf("107.182.186.227")>0){
         return false;
       }
  return (
    // iOS standalone (PWA)
    (window.navigator.standalone === true) ||
    // 没有常见浏览器插件但能加载网页
    (!window.chrome && !window.safari)
  );
}

     export function  isInAPP22(){

       var url=getReqUrl();
       if (url.indexOf("iosbuy.com")>0||url.indexOf("thenurasia.com")>0||url.indexOf("107.182.186.227")>0){
         return false;
       }

      var BrowerName=getBrowerName();

      if(BrowerName=="Edge"||BrowerName=="Chrome"||BrowerName=="Safari"||BrowerName=="Firefox"||BrowerName=="IE"||BrowerName=="Opera"||BrowerName=="FF"){
         //this.alert_ok(this.getlan('Please_Purchase_In_APP')+" "+BrowerName);
        return false;
      }
        return true
       }

     export function needbuy() {

      var url=getReqUrl();
      if (url.indexOf("iosbuy.com")>0){
        return true;
      }

       if(getValue("needbuy")=="1"){
        return true;
       }else{
        return false;
       }

       }
//cnpm install crypto-js --save-dev
     export function  encrypt(word){
      var keyStr =  getkey();
      var key  = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
      var srcs = CryptoJS.enc.Utf8.parse(word);
      var encrypted = CryptoJS.AES.encrypt(srcs, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
      return encrypted.toString();
    }
    export function setItem(key,item){
      if(item!=undefined){
        localStorage.setItem(key,JSON.stringify(item))
        return true
      }
      return false
    }
    export function getItem(key){
      var mapp=localStorage.getItem(key)
      if(mapp!=undefined&&mapp.length>10){
        return  JSON.parse(mapp)
      }
      return undefined

    }
    export function removeItem(key){
      return localStorage.removeItem(key);
     }
     export function removeAllItem(){
      localStorage.clear();
     }



    //解密
    export function  decrypt(word){
     var keyStr = getkey();

      var key  = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
      //var srcs = CryptoJS.enc.Utf8.parse(word);

      var decrypt = CryptoJS.AES.decrypt(word, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
       return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    }

    export function  getkey(){
     return 'A1234567A9abc8ef';

     }
     // DES加密
export const encryptDesECB = (message, key) => {
  var keyHex = cryptoJs.enc.Utf8.parse(key)
  var option = { mode: cryptoJs.mode.ECB, padding: cryptoJs.pad.Pkcs7 }
  var encrypted = cryptoJs.DES.encrypt(message, keyHex, option)
  return encrypted.ciphertext.toString()
}

// DES解密
export const decryptDesECB = (message, key) => {
  var keyHex = cryptoJs.enc.Utf8.parse(key)
  var decrypted = cryptoJs.DES.decrypt(
    {
      ciphertext: cryptoJs.enc.Hex.parse(message)
    },
    keyHex,
    {
      mode: cryptoJs.mode.ECB,
      padding: cryptoJs.pad.Pkcs7
    }
  )
  return decrypted.toString(cryptoJs.enc.Utf8)
}
// DES加密
export const encryptDesCBC = (message, key, iv) => {
  var keyHex = cryptoJs.enc.Utf8.parse(key)
  var ivHex = cryptoJs.enc.Utf8.parse(iv)
  var option = { iv: ivHex, mode: cryptoJs.mode.CBC, padding: cryptoJs.pad.Pkcs7 }
  var encrypted = cryptoJs.DES.encrypt(message, keyHex, option)
  return encrypted.ciphertext.toString()
}

// DES解密
export const decryptDesCBC = (message, key, iv) => {
  var keyHex = cryptoJs.enc.Utf8.parse(key)
  var ivHex = cryptoJs.enc.Utf8.parse(iv)
  var decrypted = cryptoJs.DES.decrypt(
    {
      ciphertext: cryptoJs.enc.Hex.parse(message)
    },
    keyHex,
    {
      iv: ivHex,
      mode: cryptoJs.mode.CBC,
      padding: cryptoJs.pad.Pkcs7
    }
  )
  return decrypted.toString(cryptoJs.enc.Utf8)
}
export function getDateTime(){

  let date =  new Date();
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? ('0' + MM) : MM;
  let d = date.getDay();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let m = date.getMinutes();
  m = m < 10 ? ('0' + m) : m;
  let s = date.getSeconds();
  s = s < 10 ? ('0' + s) : s;
 return getToDay()+ ' ' + h + ':' + m + ':' + s;


}
export function getDate(){


 return getToDay() ;


}
export function getSignKey(){
  return "a2s2sdf43@dswe#fdfsdss@ssss"
 }
export function getRandom(){
 return Math.floor(Math.random() * (99999 - 999 + 1)) + 999
}
  export function getOrderNum() {
    var date = new Date();
    var seperator1 = "";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDay();
    var strhour = date.getHours();
    var strminu = date.getMinutes();
    var strsec = date.getSeconds();
    var strminsec = date.getMilliseconds();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    var currentdate = year + month + strDate+strhour+strminu+strsec+strminsec;
    return currentdate;
    }

    export function  getBrowerName(){
      var userAgent =navigator.userAgent; //取得浏览器的userAgent字符串
      if(userAgent==undefined||userAgent==null){
        return ""
      }
          var isOpera = userAgent.indexOf("Opera") > -1;
          if (isOpera) {
              return "Opera"
          }; //判断是否Opera浏览器
          if (userAgent.indexOf("Firefox") > -1) {
              return "FF";
          } //判断是否Chrome浏览器
          if (userAgent.indexOf("Chrome") > -1){
            return "Chrome";
          }
          if (userAgent.indexOf("Edge") > -1){
            return "Edge";
          }
          if (userAgent.indexOf("Safari") > -1) {
              return "Safari";
          } //判断是否Safari浏览器
          if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
              return "IE";
          }; //判断是否IE浏览器
          return "";
                }



                export   function getuuid() {
                  var len=8;
                  var radix=16;
                  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
                  var uuid = [], i;
                  radix = radix || chars.length;

                  if (len) {
                    // Compact form
                    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random()*radix];
                  } else {
                    // rfc4122, version 4 form
                    var r;

                    // rfc4122 requires these characters
                    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
                    uuid[14] = '4';

                    // Fill in random data.  At i==19 set the high bits of clock sequence as
                    // per rfc4122, sec. 4.1.5
                    for (i = 0; i < 36; i++) {
                      if (!uuid[i]) {
                        r = 0 | Math.random()*16;
                        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
                      }
                    }
                  }

                  return uuid.join('');
              }



// WEBPACK FOOTER //
// ./src/utils/pub.js